/**
 * @file Utilities for working with base64 encoded data.
 */
/**
 * Get the individual bytes of a base64 encoded datum.
 *
 * @param data The base64 encoded data.
 * @returns The individual bytes.
 */
export function getBytes(data) {
    return Uint8Array.from(atob(data), c => c.charCodeAt(0));
}
/**
 * Decode a base64 encoded datum as an integer.
 *
 * @param data The base64 encoded data.
 * @returns The decoded integer.
 */
export function getInt(data) {
    return getBytes(data).reduce((acc, byte) => 256 * acc + byte, 0);
}
/**
 * Utility functions.
 */
export var utils;
(function (utils) {
    /**
     * Add padding to a base64 encoded datum up to a multiple of 4.
     *
     * @param data The base64 encoded data.
     * @returns The base64 encoded data with the correct amount of padding.
     */
    function fixPadding(data) {
        const padding = (4 - (data.length % 4)) % 4;
        return data.padEnd(data.length + padding, '=');
    }
    utils.fixPadding = fixPadding;
    /**
     * Convert a "urlsafe" base64 encoded datum to regular base64.
     *
     * "urlsafe" in this case refers to Python's `base64.urlsafe_X` functions,
     * which replace the "+" with "-" and the "/" with "_".
     *
     * @param data The urlsafe base64 encoded data.
     * @returns The same data in regular base64 encoding.
     * @see {@link https://docs.python.org/3/library/base64.html#base64.urlsafe_b64encode}
     */
    function fromUrlsafe(data) {
        return data.replace('-', '+').replace('_', '/');
    }
    utils.fromUrlsafe = fromUrlsafe;
})(utils || (utils = {}));
